<template>
 <div id="proInfo">
   <!--宣传图-->
   <div class="poster">
     <img :src="proList[showType].logo">
     <p>{{proList[showType].alt}}</p>
     <img :src="proList[showType].poster" alt="">
   </div>
   <!--功能-->
   <div class="function clearfix">
     <div v-for="(item, i) in proList[showType].function" :key="i">
       <div>
         <p>{{item.title}}</p>
         <p><span v-html="item.content"></span></p>
         <img :src="item.icon">
       </div>
     </div>
   </div>
   <!--他们说-->
   <div class="userWord" v-if="showUserWord">
     <p><span>他们说</span></p>
     <div v-for="(item, i) in proList[showType].userWord" :key="i">
       <img :src="item.user_pic" alt="">
       <p>
         <span>“</span>
         <span>{{item.content}}</span>
         <span>”</span>
         <span>{{item.user}}</span>
       </p>
       <img :src="item.screenshot">
     </div>
   </div>
 </div>
</template>

<script>
export default {
  name: 'proInfor',
  data () {
    return {
      showType: 0,
      showUserWord: true,
      proList: [
        {
          name: 'lotteryService',
          title: '彩点助手·业主版',
          alt: '彩点助手·业主版',
          logo: './static/img/logo_ls.png',
          poster: './static/img/poster_ls.png',
          function: [
            {
              title: '打造全国知名专家和团队',
              content: '汇聚全国知名专家<br>每日赛事分析，推送及时准确<br>多维度方案排行，公平公正',
              icon: './static/img/icon03.png'
            },
            {
              title: '精细化彩友管理',
              content: '从1对1沟通到用户数据化分析<br>从赛事分析到管理<br>处处实现定向用户管理和服务',
              icon: './static/img/icon02.png'
            },
            {
              title: '大数据 云共享',
              content: '全面精准的历史数据收集<br>多维度数据模型和优化算法<br>为赛事分析提供强大辅助',
              icon: './static/img/icon01.png'
            },
            {
              title: '降低工作成本 提高工作效率',
              content: '全方位定制各式分析表格<br>一键生成宣传海报<br>微信、QQ分享，拉新更容易',
              icon: './static/img/icon04.png'
            },
            {
              title: '分级权限管理',
              content: '管理权限分级<br>彩友用户管理分级<br>推广、拉新两不误',
              icon: './static/img/icon05.png'
            },
            {
              title: '专业友好的用户体验',
              content: '体彩玩法全覆盖<br>多模式分析表格，专业有保障<br>彩店推广宣传，一键搞定',
              icon: './static/img/icon06.png'
            }
          ],
          userWord: [
            {
              user: '彩票业主：李三',
              user_pic: './static/img/yz_pic2.jpg',
              content: '彩点助手汇聚全国知名专家，每天实时更新赛事分析和专家排名，帮助我多维度筛选好专家和好分析。APP还提供很多实用工具，大大提高了我每天的工作效率，还能节省了半个人工费！花钱买服务，值！我坚信我对客户负责，客户就能满意！',
              screenshot: './static/img/screenshot_ls_01.png'
            },
            {
              user: '彩票业主：燕姐',
              user_pic: './static/img/yz_pic1.jpg',
              content: '彩点助手可以自动创建单关海报和各种形式的分析图表，而且图片自带我的推广微信二维码和彩店信息，我每天再也不用为编辑图片烦恼了！而且还能非常方便的分享到微信和QQ，简直太棒了！彩点助手真是业主福音，推广神器！',
              screenshot: './static/img/screenshot_ls_02.png'
            }
          ]
        },
        {
          name: 'buyer',
          title: '彩点助手·彩友版',
          alt: '彩点助手·彩友版',
          logo: './static/img/logo_buyer.png',
          poster: './static/img/poster_buyer.png',
          function: [
            {
              title: '实体彩店 值得信赖',
              content: '平台彩店都已通过实名认证<br/>业主身份真实有效',
              icon: './static/img/icon01.png'
            },
            {
              title: '彩店业主 贴心服务',
              content: '业主一对一了解用户需求<br/>为用户量身定制购彩分析意见<br>实时响应用户要求<br>提供快捷准确的服务',
              icon: './static/img/icon02.png'
            },
            {
              title: '体彩玩法全覆盖 选号更方便',
              content: '智能赛事分析 实时推送<br>大神分析 精准放送<br>模拟选号 方便快捷',
              icon: './static/img/icon05.png'
            },
            {
              title: '超多实用工具 免费用',
              content: '免费查看号码遗漏<br>免费查看号码走势分析<br>免费查询竞彩分析数据',
              icon: './static/img/icon06.png'
            }
          ],
          userWord: [
            {
              user: '彩友：小郑',
              user_pic: './static/img/cm_pic1.jpg',
              content: '我一直玩体彩的大乐透和排列，彩点助手里有很多查询工具，为我选号提供了便利，每天没事就进去瞧瞧，我的梦想不是赚买菜钱哦，我坚信，大奖总有一天会光顾我，哈哈~~',
              screenshot: './static/img/screenshot_buyer_02.png'
            },
            {
              user: '彩友：熊熊',
              user_pic: './static/img/cm_pic2.jpg',
              content: '网上有太多五花八门的购彩软件了，但着实用着不安心，我还是喜欢在知根知底的实体店里购彩，而且业主服务非常到位！我每天在彩点助手里查看店长推荐，真心不错哦！',
              screenshot: './static/img/screenshot_buyer_03.png'
            }
          ]
        }
      ]
    }
  },
  methods: {
    changeShowType (index) {
      this.showType = index
    },
    hideUserWord () {
      this.showUserWord = false
    }
  }
}
</script>

<style scoped lang="less">
  #proInfo{
    .poster{
      position: relative;
      width: 100%;
      height: 500px;
      img{
        position: absolute;
        &:first-child{
          top: 50px;
          left: 60px;
          border: 1px solid #dedede;
          border-radius: 23px;
        }
        &:last-child{
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          margin: auto;
        }
      }
      p{
          position: absolute;
          top: 175px;
          left: 54px;
          font-size: 18px;
          line-height: 20px;
          color: #5E5E5E;
        }
    }
    .function{
      >div{
        position: relative;
        float: left;
        width: 50%;
        box-sizing: border-box;
        padding: 30px 50px 30px 70px;
        >div{
          position: relative;
          border: 1px solid #BBBBBB;
          p{
            position: relative;
            font-size: 20px;
            color: #5E5E5E;
            padding-left: 50px;
            text-align: center;
            &:first-child{
              line-height: 50px;
              border-bottom: 1px solid #BBBBBB;
              font-weight: bold;
            }
            &:nth-child(2){
              line-height: 40px;
              height: 150px;
              span{
                position: absolute;
                top: 50%;
                left: 30px;
                transform: translateY(-50%);
                width: 100%;
              }
            }
          }
          img{
            position: absolute;
            width: 135px;
            top: -30px;
            left: -50px;
          }
        }
      }
    }
    .userWord{
      margin-top: 20px;
      padding-bottom: 100px;
      >p{
        position: relative;
        width: 100%;
        height: 0;
        border-top: 1px solid #BBBBBB;
        span{
          position: absolute;
          line-height: 40px;
          padding: 0 30px;
          top: -20px;
          left: 50px;
          background-color: #fff;
          font-size: 20px;
        }
      }
      >div{
        position: relative;
        width: 100%;
        height: 300px;
        background-color: #d4d4d4;
        margin-top: 100px;
        &:last-child{
          margin-top: 130px;
        }
        img{
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 100px;
          &:first-child{
            width: 180px;
            height: 180px;
            left: 70px;
          }
          &:last-child{
            width: 200px;
          }
        }
        p{
          position: absolute;
          top: 50px;
          left: 270px;
          width: 500px;
          height: 250px;
          span{
            display: block;
            position: absolute;
            width: 100%;
            box-sizing: border-box;
            &:nth-of-type(1),&:nth-of-type(3){
              font-family: "Cambria Math";
              font-size: 72px;
              top: 10px;
            }
            &:nth-of-type(3){
              top: 150px;
              text-align: right;
            }
            &:nth-of-type(2){
              top: 50px;
              font-size: 16px;
              line-height: 24px;
              padding: 0 50px;
            }
            &:nth-of-type(4){
              bottom: 30px;
              text-align: right;
              font-size: 16px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/proInfo.vue